module.exports = __webpack_public_path__ + "img/IS.27037f5f.svg";